export const FORM_DICTIONARY = {
    generales: {
        nombre: {
            name: "nombre_completo",
            label: "Nombre completo"
        },
        documento: {
            name: "documento",
            label: "Documento de identidad"
        },
        programa: {
            name: "programa",
            label: "Programa"
        },
        semestre: {
            name: "semestre",
            label: "Semestre"
        },
        fecha_nacimiento: {
            name: "fecha_nacimiento",
            label: "Fecha de Nacimiento"
        },
        estado_civil: {
            name: "estado_civil",
            label: "Estado Civil"
        },
        sexo_biologico: {
            name: "sexo_biologico",
            label: "Sexo biológico"
        },
        identidad_genero: {
            name: "identidad_genero",
            label: "Identidad de género"
        },
        orientacion_sexual: {
            name: "orientacion_sexual",
            label: "Orientación Sexual"
        },
        direccion_actual: {
            name: "direccion_actual",
            label: "Dirección Actual"
        },
        barrio: {
            name: "barrio",
            label: "Barrio"
        },
        lugar_procedencia: {
            name: "lugar_procedencia",
            label: "Lugar de Procedencia"
        },
        departamento: {
            name: "departamento",
            label: "Departamento"
        },
        municipio: {
            name: "municipio",
            label: "Municipio"
        },
        correo_electronico: {
            name: "correo_electronico",
            label: "Correo Electrónico"
        },
        celular: {
            name: "celular",
            label: "Número de celular"
        },
        contacto_emergencia: {
            name: "contacto_emergencia",
            label: "Contacto de emergencia"
        },
        celular_contacto_emergencia: {
            name: "celular_contacto_emergencia",
            label: "Número de celular del contacto de emergencia"
        },
        parentesco: {
            name: "parentesco",
            label: "Parentesco"
        }
    },
    general_disentimiento: {
        nombre: {
            name: "nombre_completo",
            label: "Nombre Completo"
        },
        documento: {
            name: "documento",
            label: "Documento de identidad"
        },
        servicio: {
            name: "tipo_asesoria",
            label: "Tipo de servicio"
        }
    },
    disentimiento_traslado: {
        nombre: {
            name: "nombre_completo",
            label: "Nombre Completo"
        },
        documento: {
            name: "documento",
            label: "Documento de identidad"
        },
        servicio: {
            name: "servicio",
            label: "Servicio para el cual se tomó la decisión de disentimiento"
        },
        Rinformacion: {
            name: "reconozco_informacion",
            label: "Estoy de acuerdo con la información anteriormente proporcionada y entiendo las implicaciones de mi decisión"
        },
        Profesional: {
            name: "responsable_atencion",
            label: "¿Qué psicólogo de bienestar te atendió?"
        },
        acudiente: {
            name: "nombre_acudiente",
            label: "Nombre del acudiente"
        },
        ID_acudiente: {
            name: "numero_identificacion_acudiente",
            label: "Número de identificación del acudiente"
        },
        comunicacion_decision: {
            name: "comunicacion_decision",
            label: `Debido a que el estudiante ha decidido no seguir el procedimiento recomendado, 
            ¿está dispuesto(a) a comunicar su decisión a las entidades pertinentes y acompañar al estudiante en todo lo que requiera?`
        },
        disposicion_decisiones: {
            name: "disposicion_decisiones",
            label: `¿Está dispuesto(a) a tomar las decisiones necesarias en caso de que el estudiante
                    no esté en condiciones de tomar decisiones informadas debido a su estado emocional o mental?`
        },
        confirmacion_responsabilidad: {
            name: "confirmacion_responsabilidad",
            label: "Acepto la responsabilidad como acudiente",
            titulo: "Confirmación de responsabilidad del acudiente",
            description: `En calidad de acudiente acepto la responsabilidad que se me otorga como acompañante 
            del estudiante y me comprometo a seguir las indicaciones para garantizar su seguridad y bienestar.`
        },
        declaracion_disentimiento: {
            name: "declaracion_disentimiento",
            label: "Acepto la declaración anterior"
        },
        importante_aceptacion: {
            name: "importante_aceptacion",
            label: "Acepto la información importante y entiendo las implicaciones de mi decisión"
        }
    },
    satisfaccion: {
        p1_satisfaccion: {
            name: "p1_satisfaccion",
            label: "1. ¿Qué tan satisfecho te sentiste con la atención brindada durante tu sesión de asesoría?"
        },
        p1_comentario_satisfaccion: {
            name: "p1_comentario_satisfaccion",
            label: "¿Cuéntanos por qué consideras que el servicio ofrecido por el profesional no fue óptimo?"
        },
        p2_temas_pertinentes: {
            name: "p2_temas_pertinentes",
            label: "2. ¿Consideras que los temas abordados durante la asesoría fueron pertinentes y acordes a tus necesidades o situación personal?"
        },
        p2_comentario_temas: {
            name: "p2_comentario_temas",
            label: "¿Cuéntanos por qué consideras que los temas abordados no son pertinentes y acordes a tus necesidades o situación personal?"
        },
        p3_estrategias_utiles: {
            name: "p3_estrategias_utiles",
            label: "3. ¿Consideras útiles las estrategias o herramientas ofrecidas durante la asesoría para manejar tu situación?"
        },
        p3_comentario_estrategias: {
            name: "p3_comentario_estrategias",
            label: "¿Cuéntanos por qué consideras que las estrategias o herramientas ofrecidas no son útiles?"
        },
        p4_comunicacion: {
            name: "p4_comunicacion",
            label: "4. ¿La comunicación y empatía del profesional que te brindó la asesoría fue?"
        },
        p4_comentario_comunicacion: {
            name: "p4_comentario_comunicacion",
            label: "¿Cuéntanos por qué consideras que el servicio ofrecido por el profesional no fue óptimo?"
        },
        p5_formacion_integral: {
            name: "p5_formacion_integral",
            label: "5. ¿Consideras que el servicio recibido aporta a tu formación integral? (física, psicoafectiva, cognitiva, cultural, axiológica y social)"
        },
        p5_comentario_formacion: {
            name: "p5_comentario_formacion",
            label: "¿Cuéntanos por qué consideras que esta actividad no aporta a tu formación integral?"
        },
        p6_atencion_servicio: {
            name: "p6_atencion_servicio",
            label: "6. ¿La atención del servicio que usted recibió fue?"
        },
        p6_comentario_atencion: {
            name: "p6_comentario_atencion",
            label: "¿Cuéntanos por qué consideras que el servicio ofrecido no fue óptimo?"
        },
        p7_bienestar_emocional: {
            name: "p7_bienestar_emocional",
            label: "7. ¿Consideras que el servicio recibido contribuye al mejoramiento de tu bienestar emocional?"
        },
        p7_comentario_bienestar: {
            name: "p7_comentario_bienestar",
            label: "¿Cuéntanos por qué consideras que el servicio ofrecido no contribuye al mejoramiento de tu bienestar emocional?"
        },
        p8_mejoras: {
            name: "p8_mejoras",
            label: "8. Queremos mejorar nuestros servicios para ti. ¿Cuéntanos en qué debemos mejorar?"
        }
    },
    asistencia: {
        programa: {
            name: "programa",
            label: "Programa académico"
        },
        celular: {
            name: "celular",
            label: "Celular"
        },
        modalidad: {
            name: "modalidad",
            label: "Modalidad de asesoría"
        },
        tipo_asesoria: {
            name: "tipo_asesoria",
            label: "Selecciona el tipo de asesoría recibida"
        },
        forma_asesoria: {
            name: "forma_asesoria",
            label: "Selecciona la forma de asesoría"
        },
        funcionario_paspe: {
            name: "funcionario_paspe",
            label: "Profesional Asignado"
        },
        funcionario_paspe_select: {
            name: "funcionario_paspe",
            label: "Selecciona el profesional que te atendió"
        }
    },
    consentimiento: {
        general: {
            tipo_asesoria_individual: {
                name: "tipo_asesoria_individual",
                label: "Tipo de Asesoría Individual"
            },
            tipo_asesoria_consentimiento: {
                name: "tipo_asesoria_consentimiento",
                label: "Tipo de Asesoría"
            },
            nombre_completo_consent: {
                name: "nombre_completo_consent",
                label: "Nombre completo"
            },
            identificacion_consent: {
                name: "identificacion_consent",
                label: "Identificación" 
            },
            celular_consent: {
                name: "celular_consent",
                label: "Celular"
            },
            contacto_emergencia_1: {
                name: "contacto_emergencia_1",
                label: "Primer contacto de emergencia"
            },
            celular_contacto_1: {
                name: "celular_contacto_1",
                label: "Número de celular"
            },
            parentesco_contacto_1: {
                name: "parentesco_contacto_1",
                label: "Parentesco"
            },
            contacto_emergencia_2: {
                name: "contacto_emergencia_2",
                label: "Segundo contacto de emergencia"
            },
            celular_contacto_2: {
                name: "celular_contacto_2",
                label: "Número de celular"
            },
            parentesco_contacto_2: {
                name: "parentesco_contacto_2",
                label: "Parentesco"
            }
        },
        crisis: {
            name: "consentimiento_crisis",
            label: "Consentimiento para atención en crisis"
        }
    },
    fichas: {
        general: {
            nombre_eps: {
                name: "nombre_eps",
                label: "Nombre EPS"
            },
            sisben: {
                name: "sisben",
                label: "#Sisbén"
            },
            no_vinculado: {
                name: "no_vinculado",
                label: "No vinculado"
            },
            grupo_priorizado: {
                name: "grupo_priorizado",
                label: "Nombre del grupo priorizado"
            },
            se_auto_reconoce_grupo_priorizado: {
                name: "se_auto_reconoce_grupo_priorizado",
                label: "Se auto Reconoce"
            },
            certificado_grupo_priorizado: {
                name: "certificado_grupo_priorizado",
                label: "Tiene Certificado"
            },
            ideacion_suicida: {
                name: "ideacion_suicida",
                label: "¿Ha presentado Ideación Suicida?"
            },
            plan_suicida: {
                name: "plan_suicida",
                label: "¿Pensaste en quitarte la vida?"
            },
            intento_suicida: {
                name: "intento_suicida",
                label: "¿Ha presentado Intento Suicida?"
            },
            conducta_suicida: {
                name: "conducta_suicida",
                label: "¿Ha presentado Conducta Suicida?"
            },
            deseo_muerte: {
                name: "deseo_muerte",
                label: "¿Deseaste estar muerto?"
            },
            deseo_danarse: {
                name: "deseo_danarse",
                label: "¿Quisiste hacerte daño?"
            },
            trataste_suicidarte: {
                name: "trataste_suicidarte",
                label: "¿Trataste de quitarte la vida?"
            },
            toma_medicamentos: {
                name: "toma_medicamentos",
                label: "¿Tomas medicamentos de forma regular?"
            },
            nombre_medicamentos: {
                name: "nombre_medicamentos",
                label: "¿Cuáles medicamentos tomas?"
            },
            diagnostico_previo: {
                name: "diagnostico_previo",
                label: "¿Tiene diagnóstico previo?"
            },
            diagnostico: {
                name: "diagnostico",
                label: "¿Cuál es tu diagnóstico?"
            }
        },
        unica_sesion: {
            descripcion_problematica: {
                name: "descripcion_problematica",
                label: "Descripción de la Problematica"
            },
            motivo_consulta: {
                name: "motivo_consulta",
                label: "Motivo de Consulta"
            },
            resumen_procedimiento: {
                name: "resumen_procedimiento",
                label: "Resumen del Procedimiento"
            },
            observacion_recomendaciones: {
                name: "observacion_recomendaciones",
                label: "Observaciones y Recomendaciones"
            }
        },
        psicologia: {
            descripcion_motivo_consulta: {
                name: "descripcion_motivo_consulta",
                label: "Descripción del motivo de la consulta"
            },
            motivo_consulta: {
                name: "motivo_consulta",
                label: "Motivo de la Consulta"
            },
            informacion_personal_familiar: {
                name: "informacion_personal_familiar",
                label: "Información Personal y Familiar"
            },
            informacion_academica: {
                name: "informacion_academica",
                label: "Información Académica"
            },
            aspectos_relevantes: {
                name: "aspectos_relevantes",
                label: "Aspectos relevantes - anotaciones"
            },
        },
        crisis: {
            descripcion_crisis: {
                name: "descripcion_crisis",
                label: "Descripción de la Crisis"
            },
            motivo_crisis: {
                name: "motivo_crisis",
                label: "Motivo de la Crisis"
            },
            resumen_procedimiento: {
                name: "resumen_procedimiento",
                label: "Resumen del Procedimiento Realizado"
            },
            recomendaciones: {
                name: "recomendaciones",
                label: "Recomendaciones"
            },
            seguimiento_1: {
                name: "seguimiento_1",
                label: "Seguimiento 1"
            },
            seguimiento_2: {
                name: "seguimiento_2",
                label: "Seguimiento 2"
            },
            seguimiento_3: {
                name: "seguimiento_3",
                label: "Seguimiento 3"
            },
            seguimiento_4: {
                name: "seguimiento_4",
                label: "Seguimiento 4"
            },
            seguimiento_5: {
                name: "seguimiento_5",
                label: "Seguimiento 5"
            },
            seguimiento_6: {
                name: "seguimiento_6",
                label: "Seguimiento 6"
            },
            nivel_riesgo: {
                name: "nivel_riesgo",
                label: "Nivel de riesgo"
            }
        },
        comunicativa: {
            remitido_por: {
                name: "remitido_por",
                label: "Remitido por"
            },
            diagnostico_comunicativo: {
                name: "diagnostico_comunicativo",
                label: "Diagnóstico"
            },
            examenes_adjuntos: {
                name: "examenes_adjuntos",
                label: "Exámenes adjuntos"
            },
            antecedentes_comunicativos_detalle: {
                name: "antecedentes_comunicativos_detalle",
                label: "Problemas de Habla, Lenguaje, Audición, Lectura o Escritura (Edad de aparición, tratamientos recibidos, duración, evolución)"
            },
            antecedentes_familiares_comunicativos: {
                name: "antecedentes_familiares_comunicativos",
                label: "¿Algún miembro de su familia ha presentado problemas comunicativos?"
            },
            motivo_asesoria_comunicativa: {
                name: "motivo_asesoria_comunicativa",
                label: "Motivo de la asesoría"
            },
            con_quien_vive: {
                name: "con_quien_vive",
                label: "¿Con quién vive?"
            },
            ocupacion_familiar: {
                name: "ocupacion_familia",
                label: "Ocupación de los miembros de la familia"
            },
            info_hermanos: {
                name: "info_hermanos",
                label: "Número de hermanos y lugar que representa"
            },
            comunicacion_familiar: {
                name: "comunicacion_familiar",
                label: "Cómo considera la comunicación familiar"
            },
            actividades_tiempo_libre: {
                name: "actividades_tiempo_libre",
                label: "¿Qué actividades realiza en su tiempo libre?"
            },
            habcom_leer: {
                name: "habcom_leer",
                label: "Leer"
            },
            habcom_escribir: {
                name: "habcom_escribir",
                label: "Escribir"
            },
            habcom_escuchar: {
                name: "habcom_escuchar",
                label: "Escuchar"
            },
            habcom_hablar: {
                name: "habcom_hablar",
                label: "Hablar"
            },
            necesidad_escribir_leer: {
                name: "necesidad_escribir_leer",
                label: "¿Siente la necesidad de escribir o leer? Describa: leer"
            },
            necesidad_comunicacion: {
                name: "necesidad_comunicacion",
                label: "¿Necesita usted constantemente proporcionar informacion o comunicarse? Describa"
            },
            necesidad_recepcion_informacion: {
                name: "necesidad_recepcion_informacion",
                label: "¿Necesita usted constantemente recibir información? Describa"
            },
            desempeno_academico: {
                name: "desempeno_academico",
                label: "Desempeño Académico"
            },
            desempeno_academico_influenciado: {
                name: "desempeno_academico_influenciado",
                label: "Cree usted que su comunicación ha influidfo en su desempeño académico? Describa"
            },
            personas_entienden_comunicacion: {
                name: "personas_entienden_comunicacion",
                label: "¿La gente le entiende cuando habla?"
            },
            pryeccion_voz_adecuada: {
                name: "pryeccion_voz_adecuada",
                label: "¿Considera que su proyección de voz es adecuada?"
            },
            habla_rapido: {
                name: "habla_rapido",
                label: "¿Habla rápido?"
            },
            habla_lento: {
                name: "habla_lento",
                label: "¿Habla lento?"
            },
            muletillas: {
                name: "muletillas",
                label: "¿Usa muletillas al hablar?"
            }
        },
        cognitiva: {
            problema_salud_especial: {
                name: "problema_salud_especial",
                label: "¿Tiene algún problema de salud que requiera atención especial?",
                detalle: "detalle_problemas_salud"
            },
            problema_vision: {
                name: "problema_vision",
                label: "¿Problemas de visión?",
                detalle: "detalle_problemas_vision"
            },
            problema_audicion: {
                name: "problema_audicion",
                label: "¿Problemas de audición?",
                detalle: "detalle_problemas_audicion"
            },
            alteracion_sueno: {
                name: "alteracion_sueno",
                label: "¿Presenta alteraciones de sueño?",
                detalle: "detalle_alteracion_sueno"
            },
            actualmente_esta_medicado: {
                name: "actualmente_esta_medicado",
                label: "¿Se encuentra medicado actualmente?",
                detalle: "detalle_esta_medicado"
            },
            antecedentes_neurologicos: {
                name: "antecedentes_neurologicos",
                label: "¿Presenta antecedentes neurológicos?",
                detalle: "detalle_antecedentes_neurologicos"
            },
            asistencia_terapia_neuropsicologica: {
                name: "asistencia_terapia_neuropsicologica",
                label: "¿Asistió a terapia neuropsicológica?",
                detalle: "detalle_terapia_neuropsicologia"
            },
            motivo_consulta_cognitiva: {
                name: "motivo_consulta_cognitiva",
                label: "Descripción del Motivo de Consulta"
            },
            motivo_consulta_cognitiva_especifica: {
                name: "motivo_consulta_cognitiva_especifica",
                label: "Motivo Específico de la Consulta"
            },
            informacion_personal_familiar:{
                name: "informacion_personal_familiar",
                label: "Información Personal y Familiar"
            },
            calificacion_desempeno_cognitivo: {
                name: "calificacion_desempeno_cognitivo",
                label: "Calificación Desempeño Actual"
            },
            asignaturas_modalidad_actual: {
                name: "asignaturas_modalidad_actual",
                label: "Asignaturas cursando / Modalidad"
            },
            influencia_desempeno:{
                name: "influencia_desempeno",
                label: "¿Qué cree que influye en su desempeño? (Especifique)"
            },
            metodo_estudio_planificacion: {
                name: "metodo_estudio_planificacion",
                label: "¿Qué método de estudio utilizas actualmente? ¿Como planificas el tiempo?"
            },
            aspectos_revelantes_anotaciones: {
                name: "aspectos_revelantes_anotaciones",
                label: "Aspectos Relevantes - Anotaciones:"
            }
        }
    }
}
